import { TRANSFER_DIRECTION_LABELS, type TransferDirection } from '@bingo/shared';
import { useT } from '../lib/i18n';

const ARROW: Record<TransferDirection, string> = { arrival: '↘', departure: '↗', intercity: '↔' };

/** Small badge for a transfer: direction arrow and short label; a tick when the flight or train was checked. */
export function TransferBadge({ d, checked }: { d: TransferDirection; checked?: boolean }) {
  const t = useT();
  return (
    <span className={`badge tr-badge tr-${d}`} title={`${t(TRANSFER_DIRECTION_LABELS[d])}${checked ? ` · ${t('Flight or train checked')}` : ''}`}>
      {ARROW[d]} {t(TRANSFER_DIRECTION_LABELS[d])}{checked ? ' ✓' : ''}
    </span>
  );
}
